import { useContext, useEffect, useState } from 'react'
import AppContext from '../context/app'
import { BASE_COUNTRY_ISO } from '../../constants'

export default function useGetPrice(product) {
    const { country, prices, promotions } = useContext(AppContext)
    const [price, setPrice] = useState(null)
    const [baseprice, setBaseprice] = useState(null)

    const property = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
        'pimcoreProductionId' :
        'pimcoreStagingId'

    useEffect(() => {
        if (!product || !prices || !promotions) return
        
        const id = product[property]
        if(!id) return
        
        const countryPrices = prices[id]
        if(!countryPrices) return

        const bp = countryPrices[BASE_COUNTRY_ISO]
        const p = countryPrices[country?.countryIso]
        if(!bp) return

        // console.log(bp, p)
        setBaseprice(bp)
        setPrice(p || bp)
    }, [product, country, prices, promotions])
    
    return { price, baseprice }
}
